import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Csloping(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>
      
      <Helmet>
 
 <title>Learn Free PHP Looping Statement Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php Looping Statement tutorial for beginners.Looping Statement in Php is used to repeat a particular piece of cards until the given condition is false. Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,php looping statements examples,looping statement in php,php for loop statement,programming language,tutorial for begineers,Php Looping Statement,php foreach statement,Php looping Statement Types" />
 <link rel="canonical" href="https://www.codeexampler.com/php-looping-statement" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Looping Statement</h1>
    <div className="first">
        <a href="/php-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">The looping statement in Php uses to repeat a particular piece of cards until the given condition is false.
</p>
<h2 className="mt-4 mh2">There are three types of looping statements in Php programming:
</h2>
<h3 className="mt-4 ">1, while loop in the Php statement<br/>
2, Do-while looping in Php statement<br/>
3, For looping in Php statement<br/>

</h3>
<h2 className="mt-4 mh2">1, While loop in Php:</h2>
<p className="mt-3 para">In a while loop for Php, the loop's body is Execute until the condition is false.
</p>
<h2 className="mt-4 mh2">while loop syntax in Php</h2>


      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">while</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-7">condition</span>
            <span className="qwerty-2">)</span>
              {"\n"}
            <span className="qwerty-2">&#123;</span>
              {"\n"} 
            <span className="qwerty-2">  -  </span>
            {"\n"} 
              <span className="qwerty-3">  statement</span>
              {"\n"} 
              <span className="qwerty-2">  -  </span>
              {"\n"}
            <span className="qwerty-2">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div> 


<h2 className="mt-4 mh2">2,Do-while loop:</h2>
<p className="mt-3 para">In the do-while loop a condition will be given and that will be checked after the execution of the body of the loop.
</p>

    
<h2 className="headings">Do-while loop Php Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">do </span>
            <span className="qwerty-2">&#123;</span>
              {"\n"} 
              <span className="qwerty-3">  statement</span>
              {"\n"} 
              <span className="qwerty-3">  statement</span>
              {"\n"} 
              <span className="qwerty-2">  -  </span>
              {"\n"}
              <span className="qwerty-2">  while</span>
              <span className="qwerty-3"> (</span>
              <span className="qwerty-4">condition</span>
              <span className="qwerty-3">);</span>
              {"\n"} 
            <span className="qwerty-2">&#125;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  


<h2 className="mt-4 mh2">3, For loop Php:</h2>
<p className="mt-3 para">1, In the for loop Php, the body of the loop will be executed until the given condition is false<br/>
2, This for loop uses to repeat a particular piece of code for a fixed no of times<br/>
3, In the for loop Php must use two semicolons<br/>
</p>


<h2 className="headings">For loop Php Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
              <span className="qwerty-6">for</span>
              <span className="qwerty-7"> (</span>
              <span className="qwerty-5"> statement</span>
              <span className="qwerty-7">; </span>
              <span className="qwerty-3">condition</span>
            <span className="qwerty-7">;</span>
            <span className="qwerty-5">statement</span>
            <span className="qwerty-7">)</span>
              {"\n"} 
              <span className="qwerty-4">  statement</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/php-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csloping;